import React, {PropTypes} from 'react';
import { Link } from 'react-router';
import './club.scss';

const ClubRow = ({club, loading}) => {
  // const savingsExist = NumberFormatter.scrubFormatting(savings.monthly) > 0;
  // const savingsClass = savingsExist ? 'savings' : 'loss';
  // const resultLabel = savingsExist ? 'Savings' : 'Loss';

  return (
    <tr>
      <td>
        <Link to={"/klubb/" + club.id}>
          {club.name}
        </Link>
      </td>
      <td>
        {'Antall medlemmer: '}
        {club.member_count}
      </td>
    </tr>
  );
};

// Note that this odd style is utilized for propType validation for now. Must be defined *after*
// the component is defined, which is why it's separate and down here.
ClubRow.propTypes = {
  club: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default ClubRow;



/** WEBPACK FOOTER **
 ** ./src/components/club/ClubRow.js
 **/